import { FC } from 'react';

interface CenteredBoxProps {
  style?: React.CSSProperties;
}

// Contents are centered in parent both vertically and horizontally
export const CenteredBox: FC<React.PropsWithChildren<CenteredBoxProps>> = ({
  style,
  children,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        flexDirection: 'column',
        ...style,
      }}
    >
      {children}
    </div>
  );
};

export default CenteredBox;
